<template>
    <div class="devuces-icon">
      <img src="@/assets/device-icon.png" alt="">
    </div>
</template>
<script>
export default {}
</script>
<style>
  .devuces-icon {
    margin-right: 15px;
    width: 25px;
  }

</style>
